import { useFormItemContext } from './FormItemContext';

export interface IFormItemAccessibility {
  labelId: string | undefined;
  attributes: Pick<
    React.InputHTMLAttributes<HTMLInputElement>,
    'id' | 'aria-invalid' | 'aria-required' | 'aria-readonly'
  >;
}

/**
 * Trasforma le informazioni di validazione e dello schema di validazione
 * negli attributi di accessibilità da applicare all'input.
 */
export function useFormItemAccessibility(): IFormItemAccessibility {
  const { ariaLabelId, errors, validation, readonly } = useFormItemContext();

  return {
    labelId: ariaLabelId,
    attributes: {
      id: ariaLabelId,
      'aria-required': validation?.required ? 'true' : undefined,
      'aria-invalid': (errors?.length ?? 0) > 0 ? 'true' : undefined,
      'aria-readonly': readonly ? 'true' : undefined,
    },
  };
}
